import { Color } from '@arritech/shared/types';
import { Size } from '@arritech/shared/types';
import { NotificationStatus, Status } from '@arritech/shared/types';
import { IconNameOrString, Icons } from '../Icon/Icon.model';
import type { TooltipOptions } from '../Tooltip/Tooltip.model';
import type { RouteLocationRaw } from 'vue-router';

export type ButtonRouteLocation = RouteLocationRaw & {
	split?: boolean;
	splitBreakpoint?: number;
};

export const ButtonVariant = {
	DEFAULT: 'default',
	GHOST: 'ghost',
	OUTLINE: 'outline',
	NAKED: 'naked',
};
export type ButtonVariant = (typeof ButtonVariant)[keyof typeof ButtonVariant];

export const ButtonSize = Size;
export type ButtonSize = Size;

export interface ButtonProps {
	label: string;
	to?: ButtonRouteLocation | null;
	href?: string | null;
	color: Color;
	status: NotificationStatus | Status | null;
	variant: ButtonVariant;
	buttonType?: 'button' | 'submit' | 'reset';
	component: 'button' | 'a' | 'router-link';
	size: Size;
	fullWidth?: boolean;
	action?: () => void;
	disabled?: boolean;
	locked?: boolean;
	icon?: IconNameOrString;
	hoverIcon?: IconNameOrString;
	endIcon?: IconNameOrString;
	tooltip?: string | TooltipOptions;
	square?: boolean;
}

export const ButtonIcon = Icons;
